module.exports = __webpack_public_path__ + "static/media/servisAkademi.0edeb533.png";